// extracted by mini-css-extract-plugin
export var wrapper = "PicturesSection-module--wrapper--gEFN5";
export var buttonWrapper = "PicturesSection-module--buttonWrapper--LmH5R";